import { render, staticRenderFns } from "./supplierInfoCard.vue?vue&type=template&id=4d4ac933&scoped=true"
import script from "./supplierInfoCard.vue?vue&type=script&lang=js"
export * from "./supplierInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ac933",
  null
  
)

export default component.exports